import { MDBDataTable } from "mdbreact";
import { React, useMemo, useState, useEffect, useContext } from "react";
import { API_BASE_URL } from "../../utils/config";
import axios from "axios";
// import { FaImage, FaUserEdit } from "react-icons/fa";
// import { MdDeleteForever } from "react-icons/md";
import MdDeleteForever from "../../Img/delete.png";
import FaUserEdit from "../../Img/edit user.png";
import SideBar from "../SideBar";
import TopNavBar from "../TopNavBar";
import Spinner from "../Spinner";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import GlobalContext from "../../context/GlobalContext";
import { Link } from "react-router-dom";
import CreateCategoryImg from "../../Img/create tag.png";
import DetailsImg from "../../Img/details.png";
import UpdateImg from "../../Img/update.png";
import BackImg from "../../Img/back.png";
import SaveImg from "../../Img/save.png";
import NewTopNavBar from "../NewTopNavBar";
const CreateTags = () => {
  const [apiResponse, setApiRespose] = useState([]);
  const [tag, setTag] = useState([]);
  const [collaps, setCollaps] = useState(true);
  const [loader, setLoader] = useState(false);
  const [tagModalShow, setTagModalShow] = useState(false);
  const [categoryLoading, setCtegoryLoading] = useState(false);

  const [categoryId, setCategoryId] = useState();
  const [show, setShow] = useState(false);
  const [editTagModalShow, setEditTagModalShow] = useState(false);

  const [tagFormData, setTagFormData] = useState({
    name: "",
    id: "",
    count: "",
  });
  const { notificationCount, setNotificationCount } = useContext(GlobalContext);
  const [description, setDescription] = useState("");
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
    },
  };
  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };

  const getAllTags = () => {
    //const url="http://localhost/testsite"
    //API_BASE_URL
    const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/tags`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        setApiRespose(res.data);

        setTag(res.data);

        console.log(res.data);
        setLoader(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let tagData = tag
    ? tag.map((data) => {
        let obj = {
          name: data.name,
          description: data.description,
          id: data.id,
          count: data.count,
        };
        return obj;
      })
    : "";

  const rolles = localStorage.getItem("roles");

  const CustomToastWithLinkDeleteTag = () => (
    <div>
      To delete this tag, please,
      <Link className="px-1" to="/table-posts">
        Click here
      </Link>
      to transfer associated articles.
    </div>
  );

  const handleDelete = (id, tag_name) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Tag?"
    );
    if (!confirmed) {
      return;
    }

    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/tags/${id}`, config)
      .then((res) => {
        console.log(res);
        if (res.data.count > 0) {
          toast.error(CustomToastWithLinkDeleteTag);
        } else {
          setCtegoryLoading(false);
          axios
            .delete(
              `${API_BASE_URL}/wp-json/wp/v2/tags/${id}?force=true`,
              config
            )
            .then((response) => {
              // Handle the response here
              // setShowCreateCategory(true)
              setCtegoryLoading(true);
              toast.success("Tag Deleted Successfully");
              console.log(response.data);

              // notification count start
              setNotificationCount(notificationCount + 1);

              let notification_count_specific_user = {
                user_id: localStorage.getItem("current_user_Id"),
                count_value: res.data.count_value + 1,
              };
              let notification_count = {
                user_id: "",
                count_value: notificationCount,
                reflect_count: "all_admin",
              };
              if (notification_count.user_id == "") {
                // post notification on usermeta start
                axios
                  .post(
                    `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                    notification_count,
                    config2
                  )
                  .then((res) => {
                    console.log(res.data);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
              if (notification_count_specific_user.user_id != "") {
                // post notification on usermeta start
                axios
                  .post(
                    `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                    notification_count_specific_user,
                    config2
                  )
                  .then((res) => {
                    console.log(res.data);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
              // notification count end

              // recomandation data

              let notification_api_data = {
                author: localStorage.getItem("display_name"),
                // name: createUsersFormData.username,
                event_type: "Delete Tag",
                tag_name: tag_name,
                email: localStorage.getItem("userEmail"),
                // user_role: createUsersFormData.selectedRole,
                author_ids: localStorage.getItem("current_user_Id"),
              };

              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                  notification_api_data,
                  config
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });

              // recomandation data
            })
            .catch((error) => {
              console.log(error);
              // toast.error(error?.response?.data.message)
              // Handle any errors here
            });
        }
      });
  };

  // tag
  const data = useMemo(
    () => ({
      columns: [
        // {
        //     label: '#',
        //     field: 'count',
        //     width: 300,
        //     sort: 'disabled',
        //     fixedHeader: true
        // },
        {
          label: "Tag Name",
          field: "name",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Description",
          field: "description",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Usage Count",
          field: "count",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],
      rows: tagData.map((e) => {
        let current = e;
        // let count = 0
        // console.log(current)
        // count++;
        return Object.assign(e, {
          // 'count': <div>{count + 1}</div>,
          Image: <img width={30} src={e.Image} alt="" />,
          delete: (
            <div className="d-flex justify-content-center">
              {/* <button className='btn btn-primary btn-sm py-1 px-2' onClick={() => getAllSubCategories(e.id, true, e.category)}>Details</button> */}

              {/* <FaUserEdit
                onClick={() => TagEdit(e.id)}
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                size={25}
                color="#007BFF"
              /> */}
              <img
                className="mx-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                onClick={() => TagEdit(e.id)}
                src={FaUserEdit}
                alt=""
              />
              {localStorage.getItem("roles") == "administrator" ? (
                // <MdDeleteForever
                //   data-toggle="tooltip"
                //   data-placement="bottom"
                //   title="Delete"
                //   role="button"
                //   color="#007BFF"
                //   size={25}
                //   onClick={() => handleDelete(e.id, e.name)}
                // />
                <img
                  className=""
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Delete"
                  role="button"
                  onClick={() => handleDelete(e.id, e.name)}
                  src={MdDeleteForever}
                  alt=""
                />
              ) : (
                ""
              )}
              {/* <MdDeleteForever data-toggle="tooltip" data-placement="bottom" title="Delete"
                                onClick={() => handleDelete(e.id)}
                                size={25} color='#0d6efd' role='button'
                            /> */}
            </div>
          ),
          // checkbox: <div><input onChange={(e) => onchangeAuhtor(e, current)} type="checkbox" name="" id=""
          //     // checked={isChecked}
          //     checked={checkedRows.includes(current.id)}
          // /></div>
        });
      }),
    }),
    [tagData]
  );
  // tag

  // edit tag
  const TagEdit = (id) => {
    // setTagModalShow(true)
    // alert(id)
    setEditTagModalShow(true);
    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/tags/${id}`, config)
      .then((res) => {
        console.log(res.data);

        var tname = res.data.name;
        var tdescription = res.data.description;
        setDescription(tdescription);

        setTagFormData({
          id: res.data.id,
          description: tdescription,
          name: tname,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeUpdateTag = (e) => {
    if (e.target.name === "name") {
      setTagFormData({ ...tagFormData, name: e.target.value });
    }
  };
  const updateTag = (id) => {
    console.log(id);

    if (tagFormData.name == "") {
      toast.error("Enter Tag Name");
      // setTagModalShow(true)
      return;
    }
    const formData = new FormData();
    formData.append("name", tagFormData.name);
    formData.append("description", description);
    setCtegoryLoading(false);

    axios
      .post(`${API_BASE_URL}/wp-json/wp/v2/tags/${id}`, formData, config2)
      .then((res) => {
        setDescription("");
        setEditTagModalShow(false);
        console.log(res.data);
        setCtegoryLoading(true);
        setTagModalShow(false);
        toast.success("Tag Updated Successfully");

        // notification count start
        setNotificationCount(notificationCount + 1);

        let notification_count_specific_user = {
          user_id: localStorage.getItem("current_user_Id"),
          count_value: res.data.count_value + 1,
        };
        let notification_count = {
          user_id: "",
          count_value: notificationCount,
          reflect_count: "all_admin",
        };
        if (notification_count.user_id == "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count,
              config2
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        if (notification_count_specific_user.user_id != "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count_specific_user,
              config2
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        // notification count end

        // recomandation data

        let notification_api_data = {
          author: localStorage.getItem("display_name"),
          // name: createUsersFormData.username,
          event_type: "Update Tag",
          tag_name: tagFormData.name,
          email: localStorage.getItem("userEmail"),
          // user_role: createUsersFormData.selectedRole,
          author_ids: localStorage.getItem("current_user_Id"),
        };

        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
            notification_api_data,
            config
          )
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // recomandation data
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // edit tag

  const CretateCategoryModalOpen = () => {
    setTagModalShow(true);
  };
  const handleDescription = (e) => {
    let descr = e.target.value;
    setDescription(descr);
  };

  const handleClose = () => {
    setEditTagModalShow(false);
    setTagModalShow(false);
    setDescription("");
    // setCreateUsersShow(false)
    // setCreateUsersFormData({ username: '', email: '', password: '', selectedRole: '' })
    // setErrors("")
  };
  const handleChangeCreateTag = (e) => {
    console.log(e.target.value);
    if (e.target.name === "name") {
      setTagFormData({ ...tagFormData, name: e.target.value });
    }
  };
  const createSingleTag = () => {
    if (tagFormData.name == "") {
      toast.error("Enter Tag Name");
      setTagModalShow(true);
      return;
    }
    const formData = new FormData();
    formData.append("name", tagFormData.name);
    formData.append("description", description);
    //API_BASE_URL
    //let curUrl="http://localhost/testsite"
    setCtegoryLoading(false);
    axios
      .post(`${API_BASE_URL}/wp-json/wp/v2/tags`, formData, config2)
      .then((res) => {
        setDescription("");
        setEditTagModalShow(false);
        console.log(res.data);
        setCtegoryLoading(true);
        setTagModalShow(false);
        toast.success("Tag Created Successfully");

        // notification count start
        setNotificationCount(notificationCount + 1);

        let notification_count_specific_user = {
          user_id: localStorage.getItem("current_user_Id"),
          count_value: res.data.count_value + 1,
        };
        let notification_count = {
          user_id: "",
          count_value: notificationCount,
          reflect_count: "all_admin",
        };
        if (notification_count.user_id == "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count,
              config2
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        if (notification_count_specific_user.user_id != "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count_specific_user,
              config2
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        // notification count end

        // recomandation data

        let notification_api_data = {
          author: localStorage.getItem("display_name"),
          // name: createUsersFormData.username,
          event_type: "New Tag Created",
          email: localStorage.getItem("userEmail"),
          tag_name: tagFormData.name,
          // user_role: createUsersFormData.selectedRole,
          author_ids: localStorage.getItem("current_user_Id"),
        };

        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
            notification_api_data,
            config
          )
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // recomandation data
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // alert("kjfvj")
    // const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
    getAllTags();
  }, [categoryLoading]);

  return (
    <div>
      <div className="row g-0">
        <div
          style={{ minHeight: "90vh" }}
          className={
            collaps ? "column right-column  col" : "column right-column  col "
          }
        >
          <div className="w-100">
            <NewTopNavBar />
          </div>
          {/* modal start */}

          <div>
            {/* create category */}
            <Modal show={tagModalShow} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Create Tag</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <div className="row g-0 w-100 ">
                  <div className="col-3"></div>
                  <div className="col-12">
                    <form>
                      <div className="form-group my-2">
                        {/* <label for="exampleInputEmail1">Category Image:</label> */}
                        <div className="ms-4 my-2">
                          {/* <img height={50} width={50}
                                                    // style={{ width: "100px", height: "100px" }}
                                                    src={tagFormData.image} alt="" /> */}
                        </div>
                      </div>
                      <div className="form-group">
                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>
                      <div className="form-group">
                        <label className="fw-bold" for="exampleInputEmail1">
                          Tag Name <span className="text-danger">* </span> :
                        </label>
                        <input
                          className="form-control my-2"
                          type="text"
                          name="name"
                          // value={tagFormData.name}
                          placeholder="Enter Tag name"
                          onChange={handleChangeCreateTag}
                          required
                        />

                        <label className="fw-bold" for="exampleInputEmail1">
                          Description :
                        </label>
                        <input
                          className="my-2 form-control"
                          placeholder="Enter Description"
                          type="text"
                          name="description"
                          value={description}
                          onChange={handleDescription}
                        />

                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>

                      {/*  */}
                      <div className="mt-2 text-end">
                        {/* <button onClick={() => createCategory()} type="button" className="btn btn-primary">Create</button> */}
                        <img
                          // height={40}
                          className="commonLogo"
                          onClick={() => createSingleTag()}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Create Tag"
                          role="button"
                          src={UpdateImg}
                          alt=""
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-3"></div>
                </div>
              </Modal.Body>
            </Modal>
            {/* create tag */}

            {/* update tag */}
            <Modal show={editTagModalShow} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Edit Tag</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {" "}
                <div className="row g-0 w-100 ">
                  <div className="col-3"></div>
                  <div className="col-12">
                    <form>
                      <div className="form-group">
                        <label className="fw-bold" for="exampleInputEmail1">
                          Tag Name<span className="text-danger">* </span> :
                        </label>
                        <input
                          className="form-control my-2"
                          type="text"
                          name="name"
                          value={tagFormData.name}
                          placeholder="Enter Tag name"
                          onChange={handleChangeUpdateTag}
                          required
                        />

                        <label className="fw-bold" for="exampleInputEmail1">
                          Description :
                        </label>
                        <input
                          className="my-2 form-control"
                          placeholder="Enter Description"
                          type="text"
                          name="description"
                          value={description}
                          onChange={handleDescription}
                        />

                        {/* {errors.username && <p className="error">{errors.username}</p>} */}
                      </div>

                      {/*  */}
                      <div className="mt-2 text-end">
                        {/* <button onClick={() => updateCategory(tagFormData.id)} type="button" className="btn btn-primary">Update</button> */}
                        <img
                          className="commonLogo"
                          // height={40}
                          onClick={() => updateTag(tagFormData.id)}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Update"
                          role="button"
                          src={UpdateImg}
                          alt=""
                        />
                      </div>
                    </form>
                  </div>
                  <div className="col-3"></div>
                </div>
              </Modal.Body>
            </Modal>
            {/* update tag */}
          </div>

          {/* modal end */}
          {loader ? (
            <div>
              <div
                className="w-100"
                style={{ minHeight: "80vh", padding: "15px 20px 10px 40px" }}
              >
                <div
                  style={{
                    // background: '#ececec',
                    boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                    // margin: '20px 30px'
                  }}
                  className="row w-100"
                >
                  <div className="col-12 px-5 pt-2">
                    <div className="row g-0">
                      <div className="col-8">
                        <div className="pt-3">
                          {/* <h2 className='text-center'>Knowledge Repository</h2> */}
                          <h2 className="ps-3">Manage Tags</h2>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="text-end pt-4 pe-2">
                          {/* <button onClick={CretateCategoryModalOpen} className='btn btn-primary'>Create Category</button> */}
                          <img
                            className="me-1 commonLogo"
                            // height={40}
                            onClick={CretateCategoryModalOpen}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Create Tag"
                            role="button"
                            src={CreateCategoryImg}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      {rolles == "administrator" ? (
                        <MDBDataTable
                          // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                          fixed
                          sortable
                          bordered
                          autoWidth={false}
                          data={data}
                          entries={5}
                          entriesOptions={[5, 10, 15, 20]}
                          noBottomColumns
                          disableRetreatAfterSorting={true}
                        />
                      ) : (
                        <MDBDataTable
                          // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                          fixed
                          sortable
                          bordered
                          autoWidth={false}
                          data={data}
                          entries={5}
                          entriesOptions={[5, 10, 15, 20]}
                          noBottomColumns
                          disableRetreatAfterSorting={true}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center w-100 my-5">
              <Spinner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateTags;
